exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-show {\r\n  display: block; \r\n  width:100%;\r\n  color:'00';\n}\n.selected {\r\n  text-decoration: underline;\r\n  -webkit-text-decoration-color: green;\r\n          text-decoration-color: green;\n}\n.fa {\r\n    font-size: 20px;\r\n    color:black;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7c95fd0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Autocomplete.vue
// module id = 1ABi
// module chunks = 1